import { css } from 'styled-components';

export const teamCheckboxPadding = css`
  padding-top: 26px;
`;

export const teamPencilPadding = css`
  padding-top: 20px;
`;
